import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { GENERAL_INFO, PAGE_BANNERS } from "../data/content";

export default function GeneralInfo() {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.clinic} alt="Clinic General Info" fallbackKey="clinic" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar hoursAndContact />
        <article className="flex-1 nn-content">
          <h1>{GENERAL_INFO.vision}</h1>
          <p className="nn-italic-tagline -mt-2 mb-6">{GENERAL_INFO.visionLead}</p>
          <p>{GENERAL_INFO.visionBody}</p>
        </article>
      </div>
    </div>
  );
}
